module.exports = __webpack_public_path__ + "catalog/items/firesafety/no-smoking/no-smoking.svg";